import { useQuery } from '@tanstack/react-query'

import { graphql_call as graphql_admin_call } from '../../schemas/server_admin_query'

import { query_fund_composition } from './fund_graphql'
import { keys } from './keystore'

export type FundCompositionItem = {
  asset_id: string
  asset_name: string
  asset_category: string
  share_class: string
  shares_held: number
  spv: string | null
  spv_share_class: string | null
  total_cost: number
}

export type FundCompositionResponse = {
  executed_at: string
  fund_id: string
  items: FundCompositionItem[]
}

/**
 * Hook to fetch a fund's composition (holdings breakdown) at a specific date
 */
export function useFundComposition(fundId: string, executedAt?: string) {
  return useQuery({
    queryKey: keys.admin_funds.composition(fundId, executedAt).queryKey,
    queryFn: async (): Promise<FundCompositionResponse | null> => {
      try {
        if (!fundId) return null
        const response = await graphql_admin_call({
          query: query_fund_composition,
          variables: { fund_id: fundId, executed_at: executedAt },
        })
        return response
      } catch (error) {
        console.error('Error fetching fund composition:', error)
        return null
      }
    },
    enabled: Boolean(fundId),
  })
}
